<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="processExceptionVo.pkid > 0 ? '编辑' : '新建'"
      class="processException-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="processExceptionVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="vm-separate">
        <el-form-item label="系统编号">
          <el-input v-model="processExceptionVo.billNo" placeholder="系统自动生成" disabled/>
        </el-form-item>
        <el-form-item label="登记人">
          <el-input v-model="processExceptionVo.creatorName" disabled/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="检验工段">
          <el-select v-model="processExceptionVo.processNode" @change="getProcess">
            <el-option label="制程检验（IPQC）" :value="2"/>
            <el-option label="入库检验（FQC）" :value="3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="条形码">
          <el-input v-model="processExceptionVo.barcode" @keyup.enter.native="getBarcodeInfo()"/>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="工单号">
            <el-input v-model="processExceptionVo.orderNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单数量">
            <el-input v-model="processExceptionVo.orderNum" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="规格型号">
            <el-input v-model="processExceptionVo.specification"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="processExceptionVo.materialNo" disabled placeholder="请选物料">
              <el-button slot="append" @click="$refs.materialSelect.open()"> 选择</el-button>
            </el-input>
            <material-select ref="materialSelect" @select="materialSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料名称">
            <el-input v-model="processExceptionVo.materialName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单备注">
            <el-input v-model="processExceptionVo.orderNote" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="工序">
            <el-input v-model="processExceptionVo.processName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="异常/不良描述">
            <el-input v-model="processExceptionVo.processDesc" type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vm-separate">
        <el-form-item label="供应商名称">
          <el-input v-model="processExceptionVo.supplierName" placeholder="请选择供应商">
            <el-button slot="append" @click="$refs.supplierSelect.open()"> 选择</el-button>
          </el-input>
          <supplier-select ref="supplierSelect" @select="supplierSelect"/>
        </el-form-item>
        <el-form-item label="供应商代码">
          <el-input v-model="processExceptionVo.supplierCode" disabled/>
        </el-form-item>
      </div>
      <!--      <div class="vm-separate">-->
      <!--        <el-form-item label="旧物料号">-->
      <!--          <el-input v-model="processExceptionVo.mappingMaterialNo"/>-->
      <!--        </el-form-item>-->
      <!--      </div>-->
      <div class="vm-separate">
        <el-form-item label="数量">
          <el-input v-model="processExceptionVo.quantity"/>
        </el-form-item>
        <el-form-item label="检验数量">
          <el-input v-model="processExceptionVo.qualifiedQuantity"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="异常/不良数量">
          <el-input v-model="processExceptionVo.badQuantity"/>
        </el-form-item>
        <el-form-item label="库存数量">
          <el-input v-model="processExceptionVo.stockQuantity"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="责任部门">
          <el-input v-model="processExceptionVo.responsibilityDepartment"/>
        </el-form-item>
        <el-form-item label="是否处理：">
          <el-radio-group v-model="processExceptionVo.needHandle">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="区域负责工程师：">
          <el-input v-model="processExceptionVo.regionalManager" placeholder="请选择" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
          </el-input>
          <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
        </el-form-item>
        <el-form-item v-if="processExceptionVo.needHandle" label="处理人：">
          <el-input v-model="processExceptionVo.handleName" placeholder="请选择" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
          </el-input>
          <user-select ref="selectHandle" @select="onSelectHandle"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="处理方式">
          <el-select v-model="processExceptionVo.handleWay">
            <el-option label="复检" value="复检"/>
            <el-option label="让步接收" value="让步接收"/>
            <el-option label="NCMR" value="NCMR"/>
            <el-option label="质量改进" value="质量改进"/>
          </el-select>
        </el-form-item>
        <el-form-item/>
      </div>
      <div class="title">工序信息</div>
      <el-button type="success" plain style="margin-bottom:2px" @click="addProcess"> + 新增工序</el-button>
      <el-table :data="processExceptionVo.inspectionItems" border stripe>
        <el-table-column type="index" width="25" align="center"/>
        <el-table-column label="工序名称" prop="name" align="left">
          <template slot-scope="scope">
            <el-select v-model="scope.row.name">
              <el-option
                  v-for="item in inspectionItemsTemp"
                  :key="item.no"
                  :value="item.name"
                  :label="item.name"
                  @click.native="selectProcess(item,scope.row)"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionStandard" label="检验标准" align="center" width="240"/>
        <el-table-column prop="approver" label="检验结果" align="center" width="250">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.approver">
              <el-radio :label="0">NG</el-radio>
              <el-radio :label="1">OK</el-radio>
              <el-radio :label="2">NA</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" width="240">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请编辑工序备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="processExceptionVo.inspectionItems.splice(scope.$index,1)">移除工序</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          订单附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="processExceptionVo.attachments"
            ref="payData1"
            :data="processExceptionVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name: "ProcessExceptionEdit",
    components: {UserSelect, MaterialSelect, SupplierSelect, UploadFile},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        saveLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        inspectionItemsTemp: [],
        processExceptionVo: {
          pkid: "",
          billNo: "",
          orderNo: "",
          orderNum: "",
          orderNote: "",
          creatTime: "",
          creatorName: loginUtil.getName(),
          supplierName: "",
          supplierId: "",
          supplierCode: "",
          processNode: "",
          processDesc: "",
          materialNo: "",
          materialName: "",
          quantity: "",
          qualifiedQuantity: "",
          badQuantity: "",
          stockQuantity: "",
          responsibilityDepartment: "",
          needHandle: "",
          handleName: "",
          regionalID: "",
          handleID: "",
          handleWay: "",
          regionalManager: "",
          attachments: [],
          inspectionItems: [],
        },
        ruleValidate: {
          supplierName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.processExceptionVo.pkid = row.pkid;
          if (this.processExceptionVo.pkid > 0) {
            this.getData();
          }
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `processExceptions/${this.processExceptionVo.pkid}`)
          .then(resp => {
            this.processExceptionVo = resp.data;
            this.processExceptionVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });
            });
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
      },
      selectProcess(item,row) {
        row.inspectionStandard = item.inspectionStandard;
        console.log(item);
        console.log(row);
      },
      selectRegionalManager(row) {
        this.processExceptionVo.regionalID = row.systemUserID;
        this.processExceptionVo.regionalManager = row.employeeName;
      },
      onSelectHandle(row) {
        this.processExceptionVo.handleID = row.systemUserID;
        this.processExceptionVo.handleName = row.employeeName;
      },

      getBarcodeInfo() {
        let barcode = this.processExceptionVo.barcode;
        if (barcode.includes("_")) {
          this.processExceptionVo.barcode = barcode.split("_")[1];
        }
        if (this.processExceptionVo.barcode) {
          this.contentLoading = true;
          let params = {
            sn: this.processExceptionVo.barcode,
          };
          this.$http.get("basic", "snSerialNos/getVoBySn", params).then((res) => {
            this.processExceptionVo.orderNo = res.data.refBillNo;
            this.processExceptionVo.orderNum = res.data.orderNum;
            this.processExceptionVo.orderNote = res.data.orderNote;
            this.processExceptionVo.materialNo = res.data.materialNo;
            this.processExceptionVo.materialId = res.data.materialId;
            this.processExceptionVo.specification = res.data.specification;
            this.processExceptionVo.processName = res.data.procedureName;
            this.processExceptionVo.materialName = res.data.materialDescription;
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
        }

      },
      getProcess() {
        this.contentLoading = true;
        this.$http.get("basic",`inspectionTemplates/getProcessTemplate/${this.processExceptionVo.processNode}`).then((res)=>{
          res.data.forEach(item => {
            item.approver = 0;
          });
          this.inspectionItemsTemp = res.data;
          this.contentLoading = false;
        }).catch(() => {
          this.contentLoading = false;
        });
      },
      addProcess() {
        if(this.processExceptionVo.processNode) {
          let process = {
            name:"",
            approver:1,
            inspectionStandard:"",
            note:"",
            isAdded:true,
          };
          this.processExceptionVo.inspectionItems.push(process);
        }else {
          this.$message.error("请先选择异常环节");
        }
      },
      fileDelete(index) {
        this.processExceptionVo.attachments.splice(index, 1);
      },
      oneDelete(index) {
        this.processExceptionVo.details.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            imgUrl: "",
          };
          this.$http.get("basic", `files/getDownloadUrl?key=${params.filePath}`).then((res) => {
            if (res.success) {
              params.imgUrl = res.data;
              this.imgUrls.push(params.imgUrl);
            }
          });
          this.processExceptionVo.attachments.push(params);
        }
      },
      supplierSelect(row) {
        console.log(row);
        this.processExceptionVo.supplierName = row.name;
        this.processExceptionVo.supplierId = row.pkid;
        this.processExceptionVo.supplierCode = row.outerNO;
      },
      materialSelect(row) {
        this.processExceptionVo.materialId = row.id;
        this.processExceptionVo.materialName = row.name;
        this.processExceptionVo.materialNo = row.no;
        this.processExceptionVo.mappingMaterialNo = row.mappingMaterialNo;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.processExceptionVo.pkid > 0) {
              this.$http
                .put("basic", "processExceptions", this.processExceptionVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "processExceptions", this.processExceptionVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  top: 10% !important;
  left: 0 !important;
}
</style>
